import { createContext, useContext } from "react"

const AuthContext = createContext<{
  isAuthenticated: boolean
  isProcessing: boolean
  isProcessed: boolean
  isReady: boolean
}>({
  isAuthenticated: false,
  isProcessing: true,
  isProcessed: false,
  isReady: false,
})

export const useAppAuth = () => useContext(AuthContext)

export { AuthContext }
